import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: "/",
      redirect: "/login",
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          component: () => import("@/pages/Dashboard/dashboard"),
        },
        {
          path: "/tickets",
          name: "tickets",
          component: () => import("@/pages/Tickets/Tickets"),
        },
        {
          path: "/addticket",
          name: "addTicket",
          component: () => import("@/pages/Tickets/AddTicket"),
        },
        {
          path: "/add-ticket-international",
          name: "addTicket",
          component: () => import("@/pages/Tickets/AddTicketGatewayInternational"),
        },
        {
          path: "/ticketDetails/:id",
          name: "ticketDetails",
          component: () => import("@/pages/Tickets/TicketContent"),
        },
        ,
        {
          path: "/wallets",
          name: "walletList",
          component: () => import("@/pages/Wallets/WalletList"),
        },
        {
          path: "/ir-wallets",
          name: "irWalletList",
          component: () => import("@/pages/Wallets/IrWalletList"),
        },
        {
          path: "/walletTrans/:id",
          name: "walletTrans",
          component: () => import("@/pages/Wallets/WalletTrans"),
        },
        {
          path: "/ir-wallet-transaction/:id",
          name: "irWalletTrans",
          component: () => import("@/pages/Wallets/IrWalletTrans"),
        },
        {
          path: "/addwallet",
          name: "addWallet",
          component: () => import("@/pages/Wallets/AddWallet"),
        },
        {
          path: "/addCard",
          name: "addCard",
          component: () => import("@/pages/BankCards/AddCard"),
        },
        {
          path: "/gateways",
          name: "gatewayList",
          component: () => import("@/pages/PaymentGateway/GatewayList"),
        },
        {
          path: "/doller-gateways",
          name: "dollersGatewayList",
          component: () => import("@/pages/PaymentGateway/DollersGatewayList"),
        },
        {
          path: "/payment-qrcode-list",
          name: "PaymentQRCodeList",
          component: () => import("@/pages/PaymentGateway/PaymentQRCodeList"),
        },
        {
          path: "/gateways/:new",
          name: "gatewayList",
          component: () => import("@/pages/PaymentGateway/GatewayList"),
        },
        {
          path: "/cards",
          name: "cardList",
          component: () => import("@/pages/BankCards/CardList"),
        },
        {
          path: "/user/conf",
          name: "userConf",
          component: () => import("@/pages/User/ConfirmWizard"),
        },
        {
          path: "/user/confstatus",
          name: "confstatus",
          component: () => import("@/pages/User/Confirmation"),
        },
        {
          path: "/user/changePass",
          name: "userChangePass",
          component: () => import("@/pages/User/ChangePass"),
        },
        {
          path: "/user/changeNotification",
          name: "userChangeNotification",
          component: () => import("@/pages/User/ChangeNotification"),
        },
        {
          path: "/user/my",
          name: "userMy",
          component: () => import("@/pages/User/My"),
        },
        {
          path: "/BI",
          name: "BI",
          component: () => import("@/pages/BI/NewChart"),
        },
        {
          path: "/chartCreator",
          name: "chartCreator",
          component: () => import("@/pages/BI/AddEditBI"),
        },
        {
          path: "/BI/:id",
          name: "BI",
          component: () => import("@/pages/BI/AddEditBI"),
        },
        {
          path: "/transactions/:id",
          name: "transactions",
          component: () => import("@/pages/PaymentGateway/Transactions"),
        },
        {
          path: "/transactions",
          name: "transactions",
          component: () => import("@/pages/PaymentGateway/Transactions"),
        },
        {
          path: "/goallinks/:id",
          name: "goallinks",
          component: () => import("@/pages/GoalLinks/GoalLinkDetails"),
        },
        {
          path: "/goallinks",
          name: "goallinks",
          component: () => import("@/pages/GoalLinks/GoalLink"),
        },
        {
          path: "/identifierList",
          name: "IdentifierList",
          component: () => import("@/pages/Identifier/IdentifierList"),
        },
        {
          path: "/transactions_1",
          name: "transactions",
          component: () => import("@/pages/PaymentGateway/Transactions_1"),
        },
        {
          path: "/shepaLink",
          name: "ShepaLink",
          component: () => import("@/pages/ShepaLink/ShepaLink"),
        },
        {
          path: "/newShepaLink",
          name: "newShepaLink",
          component: () => import("@/pages/ShepaLink/newShepaLink"),
        },
        {
          path: "/factors",
          name: "Factors",
          component: () => import("@/pages/Factors/Factors"),
        },
        {
          path: "/Addfactor",
          name: "Addfactor",
          component: () => import("@/pages/Factors/AddFactor"),
        },
        {
          path: "/Addfactor/:id",
          name: "Addfactor",
          component: () => import("@/pages/Factors/AddFactor"),
        },
        {
          path: "/sharing",
          name: "Sharing",
          component: () => import("@/pages/Sharing/Sharing"),
        },
        {
          path: "/numbersepratortest",
          name: "numbersepratortest",
          component: () => import("@/pages/Factors/numberseprator_test"),
        },
        {
          path: "/reports",
          name: "Reports",
          component: () => import("@/pages/BI/reports"),
        },
        {
          path: "/Settle",
          name: "Settle",
          component: () => import("@/pages/PaymentGateway/Settle"),
        },
        {
          path: "/settlments",
          name: "settlments",
          component: () => import("@/pages/PaymentGateway/settlments"),
        },
        {
          path: "/gardesh",
          name: "gardesh",
          component: () => import("@/pages/PaymentGateway/transactionlist"),
        },
        {
          path: "/doller-gardesh",
          name: "dollerTransactionslist",
          component: () => import("@/pages/PaymentGateway/DollerTransactionslist"),
        },
        {
          path: "/gardesh_1",
          name: "gardesh",
          component: () => import("@/pages/PaymentGateway/gardesh_1"),
        },
        {
          path: "/newspgateway",
          name: "newspgateway",
          component: () => import("@/pages/ShepaLink/shepalinkGateway"),
        },
        {
          path: "/refunds",
          name: "Refunds",
          component: () => import("@/pages/Refunds/Refunds"),
        },
        {
          path: "/share",
          name: "sharegateways",
          component: () => import("@/pages/Sharing/Sharegateways"),
        },
        {
          path: "/share/:id",
          name: "ShareAndSettlement",
          component: () => import("@/pages/Sharing/ShareAndSettlement"),
        },
        {
          path: "/internal-transfer",
          name: "internalTransfer",
          component: () => import("@/pages/Services/InternalTransfer"),
        },
        {
          path: "/information",
          name: "information",
          component: () => import("@/pages/User/Information"),
        },
        {
          path: "/authentication",
          name: "authentication",
          component: () => import("@/pages/User/Authentication"),
        },
        {
          path: "/bussinesAndGateway",
          name: "bussinesAndGateway",
          component: () => import("@/pages/User/BussinesAndGateway"),
        },
        {
          path: "/deposit-list",
          name: "depositList",
          component: () => import("@/pages/DepositWithId/DepositList.vue"),
      },
      ],
    },
    {
      path: "/",
      component: () => import("@/pages/Auth/Auth"),
      children: [
        {
          path: "/inquiry-enamad/:domain",
          name: "enamad",
          component: () => import("@/pages/Auth/Enamad"),
        },
        {
          name: "login",
          path: "/login",
          component: () => import("@/pages/Auth/Login"),
        },
        {
          name: "register",
          path: "/register",
          component: () => import("@/pages/Auth/Register"),
        },
        {
          name: "forget",
          path: "/forget",
          component: () => import("@/pages/Auth/Forget"),
        },
        {
          name: "forget_step_2",
          path: "/forget_step_2",
          component: () => import("@/pages/Auth/Forget_step_2"),
        },
        
      ],
    },
    { 
      path: "*", 
      redirect: "/dashboard",
      component: () =>
          import ("@/view/layout/Layout"),
    }
  ],
});
